import React from 'react';
import {css} from '@emotion/css';
import { dark_grey_blue, color_colors_ocean, color_variants_ocean_light_1 } from '../../constants/colors';
import CheckIndicator from './CheckIndicator';

interface CheckboxGroupGroupProps {
    onChange: (selectedOptions: CheckboxOption, checked: boolean) => void
    options: CheckboxOption[]
    values: string[]
    defaultValue?: string
    onReset?: () => void
}

export interface CheckboxOption {
    label: string
    value: string
    icon?: string
}
class CheckboxGroup extends React.Component<CheckboxGroupGroupProps> {

    handleOptionSelected(option: CheckboxOption, checked: boolean) {
        if(this.props.onChange) this.props.onChange(option, checked);
    };

    parseDefaultValues(defaultValue?: string) {
        if (defaultValue === undefined || defaultValue === '') {
            return [];
        }

        return defaultValue.split('|').filter(value => value !== '');
    };

    handleReset = () => {
        if (this.props.onReset) {
            this.props.onReset();
            return;
        }

        const defaultValues = new Set(this.parseDefaultValues(this.props.defaultValue));
        const currentValues = new Set(this.props.values ?? []);

        this.props.options.forEach((option) => {
            const shouldBeChecked = defaultValues.has(option.value);
            const isChecked = currentValues.has(option.value);

            if (shouldBeChecked !== isChecked) {
                this.props.onChange(option, shouldBeChecked);
            }
        });
    };

    render() {
        const currentValueStr = (this.props.values ?? []).join('|');
        const showResetButton = this.props.defaultValue !== undefined && currentValueStr !== this.props.defaultValue;
        return (
            <div className={containerWrapper}>
                {showResetButton && (
                    <button
                        className={resetButtonStyle}
                        type="button"
                        onClick={this.handleReset}
                    >
                        Reset to default
                    </button>
                )}
                <div className={containerStyle}>
                    {this.props.options.map((option, index) => (
                        <div className="check-option" key={index} onClick={this.handleOptionSelected.bind(this, option, !this.props.values?.some(v => v == option.value))}>
                            <CheckIndicator checked={this.props.values?.some(v => v == option.value)}/>
                            {option.icon ? <img className="option-icon" src={option.icon}/> : null}
                            <span>{option.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}


const containerWrapper = css`
    position: relative;
`;

const resetButtonStyle = css`
    position: absolute;
    top: -4px;
    right: 0;
    background: none;
    border: none;
    color: ${color_colors_ocean};
    font-family: Muli;
    font-size: 12px;
    cursor: pointer;
    z-index: 1;
    padding: 4px 8px;
    border-radius: 4px;
    text-decoration: none;

    &:hover {
        background-color: ${color_variants_ocean_light_1};
    }
`;

const containerStyle = css`
    margin: 16px 0;
     >*{
     }

     .check-option {
        margin: 8px 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;

        span {
            font-family: Muli;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            color: ${dark_grey_blue};
            margin-left: 8px;
            word-break: break-all;
        }
     }

     .option-icon {
         margin-left: 16px;
     }
`;

export default CheckboxGroup;